import { useCallback } from 'react'

import { getScoreIdParts } from '@ilg-totallymoney/cardloanutils'

import useAppQueryState from '@hooks/useAppQueryState'
import { useBasin } from '@hooks/useBasin'

import { getAppConfig } from '@utils/getAppConfig'
import { getLoansAlternativeProductApplicationUrl } from '@utils/getLoansAlternativeProductApplicationUrl'
import { getMarketingTrackingData } from '@utils/getMarketingTrackingData'
import { getSessionId } from '@utils/getSessionId'

interface UseGetLoansAlternativeProductApplicationUrlOptions {
    loanAmount: number
    loanTerm: number
    productId: string
    tablePosition: number
}

const useGetLoansAlternativeProductApplicationUrl = () => {
    const appConfig = getAppConfig()
    const { appQueryState } = useAppQueryState()
    const { ids } = useBasin()
    const trackingData = getMarketingTrackingData(appQueryState)

    return useCallback(
        ({
            productId,
            loanAmount,
            loanTerm,
            tablePosition,
        }: UseGetLoansAlternativeProductApplicationUrlOptions) => {
            return getLoansAlternativeProductApplicationUrl({
                customerId: appQueryState.customerId!,
                scoreId: appQueryState.loansScoreId!,
                leadId: appQueryState.loansScoreId
                    ? getScoreIdParts(appQueryState.loansScoreId).leadId
                    : undefined,
                loanAmount,
                loanTerm,
                productId: productId,
                rowNumber: tablePosition,

                whitelabelName: appConfig.NAME_WHITELABEL!,
                customerOrigin: appQueryState.customerOrigin!,
                customerType: appQueryState.customerType!,

                m: trackingData.m,
                k: trackingData.k,
                cam: trackingData.cam,
                gclid: trackingData.gclid,
                dailyId: ids?.dailyId!,
                visitGuid: getSessionId()!,
                permanentId: ids?.permanentId!,
            })
        },
        [
            appQueryState.customerId,
            appQueryState.customerOrigin,
            appQueryState.customerType,
            appQueryState.scoreId,
            ids?.dailyId,
            ids?.permanentId,
            trackingData.cam,
            trackingData.gclid,
            trackingData.k,
            trackingData.m,
        ]
    )
}

export default useGetLoansAlternativeProductApplicationUrl
